var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "-1 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zM7.115 7.447h3.087V5.93a.318.318 0 0 0-.317-.317h-6.35a.317.317 0 0 0-.317.317v4.441a.317.317 0 0 0 .316.317h.725v.94c0 .175.12.242.269.15l1.479-.923v-2.3a1.11 1.11 0 0 1 1.108-1.108zm6.667 1.108a.317.317 0 0 0-.316-.316h-6.35a.318.318 0 0 0-.318.316v4.442a.318.318 0 0 0 .317.316h3.573a.322.322 0 0 0 .03.022l1.767 1.102c.148.092.269.025.269-.15v-.974h.712a.317.317 0 0 0 .316-.316z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9749d464e4a8b59456f59e0f8b465e89.svg";
export { ForwardRef as ReactComponent };